module.exports = __webpack_public_path__ + "images/organization/guests.a76a836ff67e77d7f911.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/organization/guests.svg
// module id = +AhJ
// module chunks = 0